export const EVENT_NAMES = {
  SEARCH: 'search',
  REWARDS_TOGGLE: 'rewards_toggle',
  MAP_REFRESH: 'map_refresh',
  MEMBER_CARD_RESCANNED: 'member_card_rescanned',
  MEMBER_CARD_RESCAN_FAILED: 'member_card_rescan_failed',
  MEMBER_CARD_OPENED: 'member_card_opened',
  MEMBER_CARD_REMOVED: 'member_card_removed',
  BARCODE_SCAN_ERROR: 'barcode_scan_error',
  ATTEMPTED_BARCODE_SCAN: 'attempted_barcode_scan',
  BARCODE_SCAN_SUCCESS: 'barcode_scan_success',
  MEMBER_CARD_SAVING_TO_APP: 'member_card_saving_to_app',
  MEMBER_CARD_REMOVING_FROM_APP: 'member_card_removing_from_app',
  MEMBER_CARD_SAVED: 'member_card_saved',
  MEMBER_CARD_NOT_SAVED: 'member_card_not_saved',
};
